import { observable, runInAction } from 'mobx';
import { ArchivesModel } from 'pages/extensions/archives';
import { CommonModel } from 'services/Main/common_services';
import { ArchiveDetailModel, IDocumentArchiveServices } from 'services/Main/documentArchive';
import { DataResponse } from 'services/response';

export type DocumentArchiveStore = {
  documentArchive: DataResponse<Array<ArchivesModel>>

  createUpdate: DataResponse<any>
  createNew: DataResponse<any>

  detail: DataResponse<ArchiveDetailModel | undefined>

  dropdownDocName: DataResponse<CommonModel[]>

};

export interface IDocumentArchivePresenter {
  createStore(): DocumentArchiveStore;
  // lấy danh sách
  getListDocumentArchive(store: DocumentArchiveStore, data: object): Promise<void>
  // thêm mới loại tài liệu
  createDocumentArchive(store: DocumentArchiveStore, data: object): Promise<void>
  // upload formdata cho file
  uploadCreateDocumentArchive(store: DocumentArchiveStore, data: object): Promise<void>
  // cập nhật loại tài liệu
  editDocumentArchive(store: DocumentArchiveStore, data: object): Promise<void>
  // get detail document archive  kho tài liệu
  getDetail(store: DocumentArchiveStore, id?: string): Promise<void>
  // xóa tài liệu
  deleteArchive(store: DocumentArchiveStore, id: string): Promise<void>

  // get dropdown tên tài liệu
  getDropdownDocumentName(store: DocumentArchiveStore, keyword?: string, actived?: boolean, companyCode?: string): Promise<void>

  downloadFileExtensions(url: string): Promise<void>
}

export function createDocumentArchivePresenter({ documentArchiveServices }: { documentArchiveServices: IDocumentArchiveServices }): IDocumentArchivePresenter {
  return {
    createStore: (): DocumentArchiveStore =>
      observable({
        documentArchive: {
          data: [],
          message: '',
          isSuccess: false,
        },
        createUpdate: {
          data: [],
          message: '',
          isSuccess: false,
        },
        createNew: {
          data: '',
          message: '',
          isSuccess: false,
        },
        detail: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        dropdownDocName: {
          data: [],
          message: '',
          isSuccess: false,
        }
      }),
    //// danh sách tài liệu
    getListDocumentArchive: async (store, dataSearch) => {
      try {
        const result = await documentArchiveServices.getListDocumentArchive(dataSearch);
        runInAction(() => {
          store.documentArchive.data = result.data;
          store.documentArchive.isSuccess = result.isSuccess;
          store.documentArchive.message = result.message;
          store.documentArchive.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // thêm mới loại tài liệu
    createDocumentArchive: async (store, dataSearch) => {
      try {
        const result = await documentArchiveServices.createDocumentArchive(dataSearch);
        runInAction(() => {
          store.createNew.data = result.data;
          store.createNew.isSuccess = result.isSuccess;
          store.createNew.message = result.message;
          store.createUpdate.isSuccess = result.isSuccess;
          store.createUpdate.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    uploadCreateDocumentArchive: async (store, data) => {
      try {
        await documentArchiveServices.uploadCreateDocumentArchive(data);
        // runInAction(() => {
        // store.createUpdate.isSuccess = result.isSuccess;
        // store.createUpdate.message = result.message;
        // });
      } catch (error) {
        console.log(error);
      }
    },
    // edit loại tài liệu
    editDocumentArchive: async (store, dataSearch) => {
      try {
        const result = await documentArchiveServices.editDocumentArchive(dataSearch);
        runInAction(() => {
          store.createUpdate.isSuccess = result.isSuccess;
          store.createUpdate.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    getDetail: async (store, id) => {
      try {
        const result = await documentArchiveServices.getDetail(id);
        runInAction(() => {
          store.detail.data = result.data;
          store.detail.isSuccess = result.isSuccess;
          store.detail.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    deleteArchive: async (store, id) => {
      try {
        const result = await documentArchiveServices.deleteArchive(id);
        runInAction(() => {
          store.createUpdate.isSuccess = result.isSuccess;
          store.createUpdate.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // get dropdown tên tài liệu
    getDropdownDocumentName: async (store, keyword, actived, companyCode) => {
      try {
        const result = await documentArchiveServices.getDropdownDocumentName(keyword, actived, companyCode);
        runInAction(() => {
          store.dropdownDocName.data = result.data;
          store.dropdownDocName.isSuccess = result.isSuccess;
          store.dropdownDocName.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    downloadFileExtensions: async (url) => {
      try {
        await documentArchiveServices.downloadFileExtensions(url);

      } catch (error) {
        console.log(error);
      }
    },
  };
}
